import * as React from "react";
import "./FileSelect.component.css";
import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
export function FileSelect({ file, readonly, fileTypes, tooltip, tooltipPosition, onChange }) {
    var _a;
    const [currentFile, setCurrentFile] = useState(file);
    const inputElement = useRef(null);
    const { t } = useTranslation();
    const onInputChanged = (file) => {
        if (!readonly && file) {
            setCurrentFile(file);
            onChange(file);
        }
    };
    const handleClick = () => {
        var _a;
        if (!readonly) {
            (_a = inputElement.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    return (React.createElement("section", { className: `file-select-container ${readonly ? "file-select-container-readonly" : ""}`, onClick: handleClick, "data-tooltip": tooltip, "data-tooltip-position": tooltipPosition },
        React.createElement("span", { className: "file-select-input" }, (_a = currentFile === null || currentFile === void 0 ? void 0 : currentFile.name) !== null && _a !== void 0 ? _a : t("common:file-select-placeholder-no-file", "No file selected")),
        React.createElement("button", { className: "file-select-button highlight-button", disabled: readonly },
            React.createElement(FontAwesomeIcon, { icon: ["fas", "folder-open"] })),
        React.createElement("input", { type: "file", className: "file-select-hidden-input", onChange: (e) => {
                onInputChanged(e.target.files[0]);
            }, ref: inputElement, disabled: readonly, accept: fileTypes === null || fileTypes === void 0 ? void 0 : fileTypes.join(",") })));
}
